module.exports = __webpack_public_path__ + "media/insulation/Cellulose-96f757a2.svg";